import type { ReactNode } from "react";
import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";

interface OutroCardProps {
    /** Brings its own size and spacing: a Rive canvas has whitespace built in, a static image does not. */
    illustration: ReactNode;
    title: string;
    bodyTexts: string[];
    sidneyPosition?: "left" | "right";
    children?: ReactNode;
}

const OutroCard = (props: OutroCardProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const sidneyPosition = props.sidneyPosition ?? "left";

    const desktopPadding =
        sidneyPosition === "right" ? "flex-row items-center pl-xxl pr-l" : "flex-row items-center pl-l pr-xxl gap-l";

    const sidneyOrderClass =
        sidneyPosition === "right" ? getStyleBasedOnBreakpoint(Breakpoint.MD, "order-last", "order-first") : "";

    const renderSidneyAnimation = () => (
        <div className={`flex items-center justify-center flex-shrink-0 ${sidneyOrderClass}`}>{props.illustration}</div>
    );

    const renderTextContent = () => (
        <div
            className={`flex flex-col gap-s flex-1 ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                "",
                "items-center text-center"
            )}`}
        >
            <div className={`flex flex-col ${getStyleBasedOnBreakpoint(Breakpoint.MD, "gap-xs", "gap-s")}`}>
                <p className="text-xl font-semibold text-p6-grey-dark">{props.title}</p>
                <div className="flex flex-col gap-xs">
                    {props.bodyTexts.map((text) => (
                        <p
                            key={text}
                            className="text-l text-p6-grey-dark whitespace-pre-wrap"
                        >
                            {text}
                        </p>
                    ))}
                </div>
            </div>
            {props.children}
        </div>
    );

    return (
        <div
            className={`bg-white border border-p6-grey-lightest rounded-button overflow-hidden flex w-full ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                desktopPadding,
                "flex-col items-center p-m"
            )}`}
        >
            {renderSidneyAnimation()}
            {renderTextContent()}
        </div>
    );
};

export default OutroCard;
